<template>
  <div class="inner">
    <ScrollupSection />
    <div class="all-area">
      <HeaderSection />
      <ContactSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../../Scrollup/Scrollup'
import HeaderSection from '../../Header/HeaderOne'
import ContactSection from '../../Contact/Contact'
import FooterSection from '../../Footer/Footer'

export default {
  name: 'Contact',
  components: {
    ScrollupSection,
    HeaderSection,
    ContactSection,
    FooterSection
  }
}
</script>

<style>

</style>